////////LIBRARY/////////
import React from 'react'
import { Route } from 'react-router-dom'

const PublicRoutes = ({ children, ...rest }) => {
	return <Route {...rest} render={(props) => children} />
}

PublicRoutes.propTypes = {}

export default PublicRoutes
